module.exports = __webpack_public_path__ + "img/wing-on-wo_banner.666c7a30.png";